import React from 'react';
import './EggTabReferralTooltip.scss';
import { persistentCookie, useCookie } from '../../utils/cookie';
import { isTruthyString } from '../../utils/parser';
import { CookieGate } from '../CookieGate/CookieGate';

export const EggTabReferralTooltip = () => {
  const cookie = useCookie(persistentCookie.referAFriend, isTruthyString);

  return (
    <CookieGate cookieState={cookie}>
      <div className="egg-tab-referral-tooltip">
        <div className="egg-tab-title">
          <div>Invite your friends!</div>
          <button
            type="button"
            className="btn-close btn-close-white"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              cookie.setCookie(true);
            }}
          />
        </div>
        <div className="egg-tab-copy">
          Earn extra mint spots and OmniGrow by sharing your referral link
        </div>
      </div>
    </CookieGate>
  );
};
